// @flow

import React, {type Node} from 'react';
import styled from 'styled-components';

import {gt} from 'app/utils/i18n';
import {
  InlineExclusiveGatewayIcon,
  InlineEndingIcon,
} from 'app/procedures/components/step-types-icons';

const StyledTitleH5 = styled.h5`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.95em;
`;

const rowClass = 'col-12 col-sm-4 mb-2 d-flex align-items-stretch';

type Props = {
  title: Node,
  ct?: 'procedure' | 'process',
  disabled?: boolean,
  addNewStep: ('processprocedure' | 'content' | 'decision' | 'ending') => void,
};

export const AddNewStepForm = ({
  ct = 'procedure',
  title,
  disabled = false,
  addNewStep,
}: Props) => (
  <div className="row justify-content-center">
    <div className="col-12 col-md-11 col-xl-10 py-2">
      <StyledTitleH5 className="text-center mb-4">{title}</StyledTitleH5>
      <div className="row">
        {ct === 'process' ? (
          <div className={rowClass}>
            <button
              className="btn btn-block btn-outline-primary"
              onClick={() => addNewStep('processprocedure')}
              disabled={disabled}
            >
              <i className="far fa-file text-body" /> {gt('Procedure')}
            </button>
          </div>
        ) : ct === 'procedure' ? (
          <div className={rowClass}>
            <button
              className="btn btn-block btn-outline-primary"
              onClick={() => addNewStep('content')}
              disabled={disabled}
            >
              <i className="fas fa-dot-circle text-body" /> {gt('Step')}
            </button>
          </div>
        ) : null}
        <div className={rowClass}>
          <button
            className="btn btn-block btn-outline-primary"
            onClick={() => addNewStep('decision')}
            disabled={disabled}
          >
            <InlineExclusiveGatewayIcon /> {gt('Decision')}
          </button>
        </div>
        <div className={rowClass}>
          <button
            className="btn btn-block btn-outline-primary"
            onClick={() => addNewStep('ending')}
            disabled={disabled}
          >
            <InlineEndingIcon /> {gt('End Step')}
          </button>
        </div>
      </div>
    </div>
  </div>
);
